/****   request.js   ****/
// 导入axios
import axios from "axios";
// 使用element-ui Message做消息提醒
import { Message } from "element-ui";

import { getToken } from "@/utils/auth";

//1. 创建新的axios实例，
const service = axios.create({
  // 公共接口--这里注意后面会讲
  /*  baseURL: "http://b2b_api.yeswedo.com.cn/",*/
  //baseURL: "https://store-api.csycj.com/", //线上数据库
  baseURL: "https://api.csycj.com/", //
  //  baseURL: "http://dev.csycj.com/",
  //baseURL: "https://devapi.csycj.com/",
 // baseURL: "https://ptest.csycj.com/",
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 20 * 10000
});
// 2.请求拦截器
// http request 拦截器
service.interceptors.request.use(
  config => {
    // 数据序列化
    config.data = JSON.stringify(config.data);

    // 设置请求头：保留已有 header，追加 Content-Type
    config.headers["Content-Type"] = "application/json;charset=UTF-8";

    // 从 Cookie 读取 token 并设置 Authorization
    const token = getToken();
    if (token) {
      config.headers.Authorization = token;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 3.响应拦截器
service.interceptors.response.use(
  response => {
    //接收到响应数据并成功后的一些共有的处理，关闭loading等
    let res = response.data; // 取到响应返回的数据
    if (res.code == 200) {
      // 可能需要返回一些操作成功，删除成功之类的提示，所以把整个信息返回，回调中取得时候记得加一层data
      return res;
    } else {
      if (res.code === -1 && res.msg === "您已退出登录或已过期") {
        // Message.error(res.msg);
        window.vm.$noLogin();
      } else {
        // 状态码如果不是200则为报错，弹出报错信息，且不返回任何数据
        /*   return Promise.reject(new Error(res || 'Error'))*/
        return Promise.reject(res.msg);
      }
    }
    /*  return response*/
  },
  error => {
    /***** 接收到异常响应的处理开始 *****/
    if (error && error.response) {
      // 1.公共错误处理
      // 2.根据响应码具体处理
      switch (error.response.status) {
        case 400:
          error.message = "错误请求";
          break;
        case 401:
          error.message = "未授权，请重新登录";
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = "请求错误,未找到该资源";
          //window.location.href = "/#/NotFound";
          break;
        case 405:
          error.message = "请求方法未允许";
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "系统维护中，请稍后再试";
          break;
        case 501:
          error.message = "网络未实现";
          break;
        case 502:
          error.message = "网络错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网络超时";
          break;
        case 505:
          error.message = "http版本不支持该请求";
          break;
        default:
          error.message = `连接错误${error.response.status}`;
      }
    } else {
      // 超时处理
      if (JSON.stringify(error).includes("timeout")) {
        Message.error("服务器响应超时，请刷新当前页");
      }
    }

    Message.error(error.message);
    /***** 处理结束 *****/
    //如果不需要错误处理，以上的处理过程都可省略
    return Promise.resolve(error.response);
  }
);
//4.导入文件
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js